import type { IconData } from '@stacksjs/iconify-core'

export const activity: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7.116 10.749L6 1.948l-1.116 8.8H1c-.552 0-1-.437-1-.976a.99.99 0 0 1 1-.978h2.116l.9-7.086C4.15.636 5.15-.124 6.245.008c.91.11 1.626.81 1.739 1.7l.899 7.086h1.974L12 16.04l1.142-7.245H19c.552 0 1 .438 1 .978s-.448.977-1 .977h-4.142l-.881 5.587a1.98 1.98 0 0 1-1.672 1.634c-1.092.165-2.113-.567-2.282-1.634l-.88-5.587z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default activity
